export default __webpack_public_path__ + "static/media/logo-bg.5529e2f1.svg";